<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DA2OIH/tc-custom/9781488006388.jpg?1718183002415" alt="This image is the cover for the book Restorer, The Graveyard Queen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Restorer, The Graveyard Queen
      </h1>
      <p class="bookDescription body article font2">
        <b>A cemetery restorer with a haunting secret must break her own rules when she meets a detective on the hunt for a killer in this romantic urban fantasy.</b><br/><br/><i>Never acknowledge the dead.</i><br/><br/><i>Never stray far from hallowed ground.</i><br/><br/><i>Never get close to the haunted.</i><br/><br/><i>Never, ever tempt fate.</i><br/><br/>My name is Amelia Gray. I’m a cemetery restorer who sees ghosts. In order to protect myself from the parasitic nature of the dead, I’ve always held fast to these rules passed down from my father . . . until now.<br/><br/>Detective John Devlin needs my help to find a killer, but he is haunted by ghosts who shadow his every move. To warn him would be to invite them into my life. I’ve vowed to keep my distance, but the pull of his magnetism grows ever stronger even as the headstone symbols lead me closer to truth and to the gossamer veil that separates this world from the next.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Stevens
      </h2>
      
      <p class="authorDescription body article">Amanda Stevens is an award-winning author of over fifty novels.&#160;Born and raised in the rural south, she now resides in Houston, Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ba27015